export * from './restore-password.component';
